import { REWARD_TIERS } from '@bulknutrients/bulk-shared-lib/constants';
import { Button } from '@components/Button/Button';
import { LoginModalUncontrolled } from '@components/LoginForm/LoginModal';

import { Paragraph } from '@components/Typography/Paragraph/Paragraph';
import { TextLink } from '@components/Typography/TextLink/TextLink';
import { useCustomer } from '@hooks/customer/useCustomer';
import { useCustomerStatus } from '@hooks/customer/useCustomerStatus';
import { useEffect, useState } from 'react';

export function CreateAccountLoyaltyPrompt({
  cartValue,
}: {
  cartValue: number;
}) {
  const { customer } = useCustomer();
  const [tier, setTier] = useState('welcome');
  const { isExisting } = useCustomerStatus();

  useEffect(() => {
    setTier(customer?.loyaltyLion?.tier ?? 'welcome');
  }, [customer]);

  let pointsPerDollar = 3;
  if (Object.hasOwn(REWARD_TIERS, tier.toUpperCase())) {
    pointsPerDollar = REWARD_TIERS[tier.toUpperCase()].earn;
  }

  if (customer) {
    return (
      <Paragraph align="center" className="text-xs">
        You're set to earn {Math.floor(pointsPerDollar * cartValue)} points
        after placing this order!
      </Paragraph>
    );
  }
  return (
    <Paragraph align="center" className="text-xs">
      {isExisting ? (
        <LoginModalUncontrolled
          trigger={
            <Button
              buttonStyle="text"
              data-umami-event-location="Quick Cart Loyalty Prompt"
            >
              Sign in
            </Button>
          }
        />
      ) : (
        <TextLink
          href="/create-account"
          data-umami-event-location="Quick Cart Loyalty Prompt"
        >
          Create an account
        </TextLink>
      )}{' '}
      to earn {Math.floor(pointsPerDollar * cartValue)} points (500 points =
      $5)!
    </Paragraph>
  );
}
